export default {
  async actionSetWithdrawalPayment({ commit }, payment) {
    commit('setWithdrawalPayment', payment)
  },
  async actionSetWithdrawalAmount({ commit }, values) {
    commit('setWithdrawalAmount', values)
  },
  async actionSetCpsPaymentList({ commit }, payments) {
    commit('setCpsPaymentList', payments)
  },
}
